import { createContext, useContext } from 'react'

import { HighlightDefinition } from 'apps/aiAutomation/components/KnowledgeEditor/components/SourceTextEditor/hooks/useHighlight'
import { KnowledgeEditorContextMissingError } from 'apps/aiAutomation/errors'

import { KnowledgeEditorSource } from './types'

export interface KnowledgeEditorContextProps {
  source: KnowledgeEditorSource
  onClose: () => void
  highlightedChunks: HighlightDefinition[]
  selectedChunkId: string | null
  setSelectedChunkId: (id: string | null) => void
}

export const KnowledgeEditorContext = createContext<KnowledgeEditorContextProps | null>(null)

export const useKnowledgeEditorContext = () => {
  const context = useContext(KnowledgeEditorContext)

  if (!context) {
    throw new KnowledgeEditorContextMissingError()
  }

  return context
}
